/** Matches backend `payment.controller.js` ONLINE_GATEWAY_RATE + round2. */
export const ONLINE_GATEWAY_RATE = 0.02;

export function round2(n) {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

/**
 * @param {number} baseInr — amount before gateway (e.g. advance due)
 * @returns {{ baseAmount: number, gatewayCharge: number, payableTotal: number }}
 */
export function onlineTotalWithGatewayFee(baseInr) {
  const base = Number(baseInr);
  if (!Number.isFinite(base) || base <= 0) {
    return { baseAmount: 0, gatewayCharge: 0, payableTotal: 0 };
  }
  const gatewayCharge = round2(base * ONLINE_GATEWAY_RATE);
  return {
    baseAmount: base,
    gatewayCharge,
    payableTotal: round2(base + gatewayCharge)
  };
}
